import React, { useMemo } from "react";
import { Avatar } from "primereact/avatar";
import PropTypes from "prop-types";
import Attachments from "./Attachments";
import "./conversations.scss";
import { downloadFileHandler } from "../../../utils/fileUtils";
import Menu from "~/components/menu/Menu";
import { useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getAdHocEscalationDisplayName } from "~/utils/fileUtils";

const Message = ({
  messageInfo,
  formatDate,
  conversation,
  deletedAt,
  setDeleteModal,
  setSelectedMessage,
  relatedType = "",
}) => {
  // const [deleteConfirmation, setDeleteConfirmation] = useState(false)
  const { id: userId, role: userRole } = useSelector((state) => state.login);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0] ? nameArray[0].charAt(0) : "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };
  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer",
    LSP_USER: "Local Team",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "Local Team Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };

  const menuItems = useMemo(
    () => [
      {
        label: "Delete Message",
        icon: "pi pi-trash",
        command: () => {
          // Remove commentId from URL when delete modal opens
          const params = new URLSearchParams(location.search);
          if (params.has("commentId")) {
            params.delete("commentId");
            params.delete("commentType");
            const newSearch = params.toString();
            const newPath = newSearch
              ? `${location.pathname}?${newSearch}`
              : location.pathname;
            navigate(newPath, { replace: true });
          }

          setDeleteModal(true);
          setSelectedMessage(conversation);
        },
      },
    ],
    [conversation, setDeleteModal, setSelectedMessage, navigate, location],
  );

  const deletedUser = messageInfo?.updatedBy || messageInfo?.userData;

  const getFormattedAttachmentName = (file) => {
    const fileName = file?.original_file_name || file?.name;
    const subCategory = file?.subCategory;

    if (subCategory && fileName) {
      return getAdHocEscalationDisplayName(
        subCategory
          .toLowerCase()
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        messageInfo?.createdAt,
        fileName,
      );
    }
    return fileName;
  };

  return (
    <div className="message-container">
      <Avatar
        label={getInitials(
          [messageInfo?.userData?.first_name, messageInfo?.userData?.last_name]
            .filter(Boolean)
            .join(" "),
        )}
        shape="circle"
        className="avatar"
      />
      <div className="message-content">
        <div className="meta-info-container">
          <div className="meta-info">
            <p className="user-name">
              {`${messageInfo?.userData?.first_name} ${messageInfo?.userData?.last_name} (${role[messageInfo?.userData?.role]})`}{" "}
            </p>
            <p className="date-time">{formatDate(messageInfo?.createdAt)}</p>
          </div>
          {!deletedAt &&
            (userId === messageInfo?.userData?.id ||
              userRole?.startsWith("GXM")) && (
              <div className="menu-container">
                <Menu menuItems={menuItems} />
              </div>
            )}
        </div>
        {messageInfo?.content && !deletedAt && (
          <p className="message">{messageInfo?.content}</p>
        )}
        {deletedAt && (
          <p className="message deleted-msg">
            Message removed by{" "}
            {`${deletedUser.first_name} ${deletedUser.last_name} (${role[deletedUser.role]}).`}
          </p>
        )}
        {messageInfo?.attachmentData.length > 0 &&
          !deletedAt &&
          messageInfo?.attachmentData.map((file, index) => {
            return (
              <Attachments
                key={index}
                file={{
                  ...file,
                  createdByData: messageInfo?.userData,
                  createdAt: messageInfo?.updatedAt,
                }}
                displayName={getFormattedAttachmentName(file)}
                icon="pi-download"
                progressBar={false}
                fileHandler={() => downloadFileHandler(file)}
                showPreviewIcon={false}
                showDescriptionIcon={true}
                id={id}
                relatedType={relatedType}
              />
            );
          })}
      </div>
    </div>
  );
};

Message.propTypes = {
  messageInfo: PropTypes.any,
  formatDate: PropTypes.func,
  conversation: PropTypes.object,
  deletedAt: PropTypes.string,
  setDeleteModal: PropTypes.func,
  setSelectedMessage: PropTypes.func,
};

export default Message;
